import { action, makeObservable, observable, computed } from "mobx";
import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { MemCommonEditorImageRejectionErrorCode } from "@mem-labs/common-editor";
import { truncate } from "lodash-es";

const IMAGE_SIZE_LIMIT_MB = 25;

export class ImageUploadRejectedModalStore extends AppSubStore {
  public code: MemCommonEditorImageRejectionErrorCode | null = null;
  public imageName: string | null = null;
  isOpen: boolean = false;

  constructor(injectedDeps: AppSubStoreArgs) {
    super(injectedDeps);

    makeObservable<this>(this, {
      imageName: observable,
      code: observable,
      isOpen: observable,
      truncatedImageName: computed,
      isTooLarge: computed,
      imageSizeLimitMb: false,
      open: action,
      close: action,
    });
  }

  public open({
    code,
    imageName,
  }: {
    code: MemCommonEditorImageRejectionErrorCode;
    imageName: string;
  }) {
    this.code = code;
    this.imageName = imageName;
    this.isOpen = true;
  }

  public close() {
    this.code = null;
    this.imageName = null;
    this.isOpen = false;
  }

  get truncatedImageName() {
    return truncate(this.imageName ?? "Image", { length: 30 });
  }

  get isTooLarge() {
    return this.code === MemCommonEditorImageRejectionErrorCode.ImageTooLarge;
  }

  get imageSizeLimitMb() {
    return IMAGE_SIZE_LIMIT_MB;
  }
}
